import { useEnvironment } from '@/composables/useEnvironment';

/**
 * Returns the passed path formatted for API calls.
 * @param {*} path
 * @param {$} override
 * @returns
 */
function getPath(path, override) {
  if (override) return `${override}${path}`;

  const { isLocal } = useEnvironment();

  if (isLocal()) {
    path = window.location.origin.concat(['/'], path);
  } else {
    path = import.meta.env.VITE_INSURANCE_API_GATEWAY_ENDPOINT.concat(['/'], path);
  }
  return path;
}

export default getPath;
